//When html finished loading
$(document).on("ready", function () {


    /** SERVICES **/

    $('body').on('click', '.service-item a', function (event) {
        event.preventDefault();
    });

    $('body').on('click', '.service-item', function (event) {
        event.preventDefault();

        var $serviceItemModal = $('#serviceItemModal');
        var $serviceItem = $(this);

        var title = $(this).data('title');
        var description = $(this).data('description');
        var servicetype = $(this).data('servicetype');
        var serviceid = $(this).data('serviceid');
        var image = $(this).data('image');
        var svg_image = $(this).data('image-svg');

        $serviceItemModal.find('.serviceItemModal-title').text(title);
        $serviceItemModal.find('.serviceItemModal-description').html(description);
        $serviceItemModal.find('.serviceItemModal-serviceId').val(serviceid);
        $serviceItemModal.find('.serviceItemModal-serviceId').attr('name', servicetype);
        if (image) {
            $serviceItemModal.find('.svg-list-image').html('');
            $serviceItemModal.find('.serviceItemModal-image').attr('src', image);
        } else {
            $serviceItemModal.find('.svg-list-image').html(svg_image);
            $serviceItemModal.find('.serviceItemModal-image').attr('src', '');
        }


        var position;

        var viewport = window.matchMedia("(min-width: 992px)");

        if (viewport.matches) {

            position = {
                top: $serviceItem.offset().top - $(window).scrollTop(),
                left: $serviceItem.offset().left + $(this).width()
            };

        } else {

            position = {
                top: $serviceItem.offset().top - $(window).scrollTop() + $serviceItem.height(),
                left: 0
            };

        }

        $serviceItemModal.modal('show');
        $serviceItemModal.animate(position);
        $('body').removeClass('modal-open');
        $('.modal-backdrop').removeClass('modal-backdrop');


        var topWhenClicked = $serviceItem.offset().top; //get the offset top of the element

        $(window).scroll(function () {

            var scrollPosition;

            if (viewport.matches) {

                scrollPosition = {
                    top: topWhenClicked - $(window).scrollTop(),
                    left: $serviceItemModal.offset().left
                };

            } else {

                scrollPosition = {
                    top: topWhenClicked - $(window).scrollTop() + $serviceItem.height(),
                    left: 0
                };

            }

            $serviceItemModal.css('top', scrollPosition.top + 'px');
        });

    });


});